import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {TextField} from 'components/interactive/forms/form-styles'
import { getLocationFromZip } from '../util'
import styled from 'styled-components' 
import Color from "constants/colors"
import {Spacer} from 'layout/util'
import FullScreenModal from 'components/static/FullScreenModal'


const Button = styled.div`
  font-family: ${props=>props.theme.fonts.h2};
  font-weight: bold;
  font-size: 14px;
  line-height: 1.5em;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align:center;

  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 25px;
  color: ${Color('blue')};
  border: 4px solid ${Color('blue')};
  -webkit-appearance: none;
  border-radius: 3px;

  &:focus {
    background-color: ${Color('blue')};
    color: white;
    text-decoration: underline;
    outline: none;
  }

  @media not all and (hover: none) {
    &:hover{
      background-color: ${Color('blue')};
      color: white;
      cursor: pointer;
    }
  }
`;


class SetLocation extends React.Component{
	constructor(props) {
		super(props)
		this.state = {
			zip: undefined,
		}
	}

	//-- redux pattern for action + action creator separation
	setLocation = (place) => {
		return {
			type: "LOCATION_SET",
			payload: place
		}
	}

	boundSetLocation = (place) => {
		this.context.store.dispatch(this.setLocation(place));
    this.props.history.push('/election/props/');
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({[target.name]: value});
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let locale = getLocationFromZip(this.state.zip)
    this.boundSetLocation(locale)
  }

	//-- to toggle visibility, pass as prop to give access to children
	toggleVisibility = (forceVisible) => {
		if(forceVisible === false) {
			this.context.store.dispatch({type:"LOCATION_FORGOTTEN"});
		}
	}

	render() {
		return(
			<FullScreenModal onToggleVisibility={this.toggleVisibility}>
        <h1>Change city</h1>
    		For this election, we're covering San Francisco and San Jose's ballot. If you vote in Santa Clara County or California, we still have stuff we can help you on. (Sorry LA, we'll get you in November.)
    		<Spacer height={30}/>
		  	<h3>Enter your zip</h3>
    		<Spacer height={15}/>
				<form onSubmit={this.handleSubmit}>
			    <TextField 
            required={true}
            type="number" 
            name="zip" 
            id="zip"
            placeholder='zipcode'
            value={this.state.zip}
            onChange={this.handleInputChange}
            maxLength="5"
            style={{textAlign:'center',backgroundColor: '#eee', marginTop:-20}}
           /> 
         </form>
    		<h3>Or choose a city</h3>
    		<Button onClick={()=>this.boundSetLocation("SF")}>I live in San Francisco</Button>
    		<Button onClick={()=>this.boundSetLocation("SJ")}>I live in San Jose</Button>
  		</FullScreenModal>
		)	
	}
}



SetLocation.contextTypes = {
  store: PropTypes.object
};

function mapStateToProps(state) {
  const locale = state.locale;
  return { locale };
}

export default connect(mapStateToProps, {})(withRouter(SetLocation));



// WEBPACK FOOTER //
// ./src/pages/june-5/components/SetLocation.js